import { render, staticRenderFns } from "./TrackingDetail.vue?vue&type=template&id=2f903298&scoped=true&lang=pug"
import script from "./TrackingDetail.vue?vue&type=script&lang=js"
export * from "./TrackingDetail.vue?vue&type=script&lang=js"
import style0 from "./TrackingDetail.vue?vue&type=style&index=0&id=2f903298&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f903298",
  null
  
)

export default component.exports